import { render, staticRenderFns } from "./customerAttributes.vue?vue&type=template&id=28916816&scoped=true&"
import script from "./customerAttributes.vue?vue&type=script&lang=js&"
export * from "./customerAttributes.vue?vue&type=script&lang=js&"
import style0 from "./customerAttributes.vue?vue&type=style&index=0&id=28916816&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28916816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28916816')) {
      api.createRecord('28916816', component.options)
    } else {
      api.reload('28916816', component.options)
    }
    module.hot.accept("./customerAttributes.vue?vue&type=template&id=28916816&scoped=true&", function () {
      api.rerender('28916816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/customerAttributes.vue"
export default component.exports